"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.composeCircleProgress = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeCircleProgress = function composeCircleProgress(args) {
    var Svg = args.Svg,
        VictoryPie = args.VictoryPie;

    var CircleProgress = function (_React$PureComponent) {
        _inherits(CircleProgress, _React$PureComponent);

        function CircleProgress() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, CircleProgress);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CircleProgress.__proto__ || Object.getPrototypeOf(CircleProgress)).call.apply(_ref, [this].concat(args))), _this), _this.getData = function () {
                return [{ x: 1, y: _this.props.currentValue }, { x: 2, y: _this.props.maxValue - _this.props.currentValue }];
            }, _this.processDataFill = function (d) {
                var color = _this.props.currentValue > _this.props.highValue ? _this.props.highColor : _this.props.lowColor;

                return d.x === 1 ? color : _this.props.defaultColor;
            }, _this.renderChart = function () {
                return _react2.default.createElement(VictoryPie, {
                    animate: { duration: _this.props.animateDuration * 1000 },
                    width: _this.props.width,
                    height: _this.props.height,
                    data: _this.getData(),
                    innerRadius: (_this.props.height - 50) / 2,
                    cornerRadius: 0,
                    labels: function labels() {
                        return null;
                    },
                    style: {
                        data: { fill: _this.processDataFill }
                    }
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(CircleProgress, [{
            key: "render",
            value: function render() {
                if (process.env.IS_WEB) {
                    return _react2.default.createElement(
                        Svg,
                        { viewBox: "0 0 " + this.props.width + " " + this.props.height },
                        this.renderChart()
                    );
                }

                return _react2.default.createElement(VictoryPie, {
                    animate: { duration: this.props.animateDuration * 1000 },
                    width: this.props.width,
                    height: this.props.height,
                    data: this.getData(),
                    innerRadius: this.props.innerRadius || (this.props.height - 50) / 2,
                    cornerRadius: 0,
                    labels: function labels() {
                        return null;
                    },
                    style: {
                        data: { fill: this.processDataFill }
                    }
                });
            }
        }]);

        return CircleProgress;
    }(_react2.default.PureComponent);

    CircleProgress.propTypes = {
        width: _react2.default.PropTypes.number,
        height: _react2.default.PropTypes.number,
        innerRadius: _react2.default.PropTypes.number,
        currentValue: _react2.default.PropTypes.number,
        highColor: _react2.default.PropTypes.string,
        lowColor: _react2.default.PropTypes.string,
        defaultColor: _react2.default.PropTypes.string,
        maxValue: _react2.default.PropTypes.number,
        highValue: _react2.default.PropTypes.number
    };

    CircleProgress.defaultProps = {
        width: 400,
        height: 400,
        highColor: "#e83e2e",
        lowColor: "#3d803f",
        defaultColor: "#cee4ad"
    };

    return CircleProgress;
};

exports.composeCircleProgress = composeCircleProgress;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-charts/lib/charts/home/CircleProgress.js
// module id = 1147
// module chunks = 0